<div>
  <button class="mat-dialog-close" mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <!-- Dialog: Header -->
  <div class="mat-dialog-header">
    <h1>{{ data?.payload.patientDetails?.name }}</h1>
  </div>

  <!-- Dialog: Content -->
  <div class="mat-dialog-body center">
    @if (data.versantFlag) {
    <div class="container">
      <div class="content"></div>
    </div>
    }
    <div id="pdfContent" class="divTable" style="width: 100%">
      <div class="divTableBody">
        <div class="divTableRow">
          <div class="divTableCell">Patient Phone #:</div>
          <div class="divTableCell">{{ data?.payload.patientDetails?.phoneNumber }}</div>
        </div>
        <div class="divTableRow">
          <div class="divTableCell">Order #:</div>
          <div class="divTableCell">
            <div>{{ data?.payload.orderNumber }}</div>
            <div>
              <strong class="order__barcode">{{ data?.payload.orderNumber }}</strong>
            </div>
          </div>
          <div class="divTableCell">Order Date:</div>
          <div class="divTableCell">{{ data?.payload?.orderDate | date : 'MM/dd/yyyy' }}</div>
        </div>
        @if (data?.payload.benefitNumber !== null && data?.payload.benefitNumber !== 'NO AUTH RE') {
        <div class="divTableRow">
          <div class="divTableCell">Benefit #:</div>
          <div class="divTableCell">
            @if (data?.payload.benefitNumber !== null) {
            <div class="order__order-number">
              {{ data?.payload.benefitNumber }}
            </div>
            }
            <div class="order__order-number">
              @if (data?.payload.benefitNumber !== null) {
              <strong class="order__barcode">{{ data?.payload.benefitNumber }}</strong>
              }
            </div>
          </div>
          <div class="divTableCell">Acuity Lab Make:</div>
          <div class="divTableCell">{{ data?.payload.orderType }}</div>
        </div>
        }
        <div class="divTableRow">
          <div class="divTableCell">Lab Name:</div>
          <div class="divTableCell">{{ data?.payload?.labDetails.name }}</div>
          <div class="divTableCell">Account:</div>
          <div class="divTableCell">{{ data?.payload.patientDetails.accountNumber }}</div>
        </div>
        <div class="divTableRow">
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
        </div>
        <div class="divTableRow">
          <div class="divTableCell">Lens Style:</div>
          <div class="divTableCell">
            {{ data?.payload.lensDetails?.lensName }}
            {{ data?.payload.lensDetails?.lensDetails }}
            {{ data?.payload.lensDetails?.color }}
          </div>
          <div class="divTableCell">Frame Name:</div>
          <div class="divTableCell">{{ data?.payload.frameDetails.name }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog: Footer/Actions -->
  <div class="mat-dialog-footer" mat-dialog-actions>
    <div class="btn-group">
      <!--      <button cdkFocusInitial class="btn btn-primary" [mat-dialog-close]="true">-->
      <!--        Close-->
      <!--      </button>-->
      <button
        style="margin: 0 0 0 auto"
        class="btn btn-primary"
        (click)="generatePDF(data.versantFlag, data?.payload.benefitNumber)"
      >
        Print
      </button>
    </div>
  </div>
</div>
